import { Account } from './account.model';

export class Case {
	id: string;
	simpleCaseId: number;
	accountId: string;
	account: Account;
	name: string;
	caseNumber: string;
	caseType: string;
	caseVenue: string;
	leadAttorney: string;
	trierOfFact: string;
	customDesignation: string;
	caseComments: string;
	documentCount: number;
	keywordIndexOutOfSync: boolean;
	caseKeywords: string;
	indexDocCount: number;
	currentCaseSizeBytes: number;
	docSize: number;
	productionJobSize: number;
	archiveJobSize: number;
	downloadSize: number;
	indexSize: number;
	dateTimeCreated: string;
	createdById: string;
	indexService: string;
}
